import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RootState } from 'app/store'
import Axios from 'constants/functions/Axios'
import { initialState } from './constant'

export const getListPromotion = createAsyncThunk(
  'promotion/list',
  async ({ query }: { query?: URLSearchParams }) => {
    const response = await Axios({
      method: 'GET',
      url: '/function/promotion',
      params: query
    })
    return response?.data
  }
)

export const getPromotion = createAsyncThunk(
  'promotion/detail',
  async ({id, query, fields}: { id: string, query?: URLSearchParams, fields: Array<string> }) => {
    const response = await Axios({
      method: 'GET',
      url: `/function/promotion/detail/${id}`,
      params: query
    })
    let data = {}
    fields.forEach((field) => {
      data[field] = response?.data?.data?.[field]
    })
    
    return { ...response?.data, data }
  }
)

export const promotionSlice = createSlice({
  name: 'promotion',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // List promotion
      .addCase(getListPromotion.pending, (state) => {
        state.list.status = 'LOADING'
      })
      .addCase(getListPromotion.rejected, (state) => {
        state.list.status = 'FAILED'
      })
      .addCase(getListPromotion.fulfilled, (state, action) => {
        state.list.status = 'SUCCESS'
        state.list.data = action.payload.data
        state.list.count = action.payload.length
      })

      // Detail promotion
      .addCase(getPromotion.pending, (state) => {
        state.detail.status = 'LOADING'
      })
      .addCase(getPromotion.rejected, (state) => {
        state.detail.status = 'FAILED'
      })
      .addCase(getPromotion.fulfilled, (state, action) => {
        state.detail.status = 'SUCCESS'
        state.detail.data = action.payload.data
      })
  },
})

export const selectPromotion = (state: RootState) => state.promotion.detail
export const selectListPromotion = (state: RootState) => state.promotion.list

export default promotionSlice.reducer
